import {createApp} from 'vue'
// @ts-ignore
import App from './App.vue'
import router from './router'
import store from './store'
// import '@varlet/ui/es/style.css'
import '@/assets/css/global.less'
import Varlet from '@varlet/ui';
import "@/utils/createGlobalMethods"
import MainLayout from '@/components/mainLayout/mainLayout.vue'
import {registeDirective} from '@/directives/index.js'
import "@/utils/init.js"
import 'vue-cropper/dist/index.css'
import 'animate.css';
import './utils/rem.js'
import 'amfe-flexible'
import 'vant/lib/index.css';
import vant from 'vant'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App)
registeDirective(app)
// 注册自定义指令
// createDirectives(app)
app.component('MainLayout',MainLayout)
app.use(Varlet)
app.use(store)
app.use(router)
app.use(vant)
app.use(ElementPlus)
app.mount('#app')
